import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { GameSearchDefaultBox } from "./game-search.default.box";
import { GameSearchMrGreenCisBox } from "./game-search.mrgreenCis.box";

export const GameSearchBox = styledByTheme(GameSearchDefaultBox)
    .forMrGreenCis(GameSearchMrGreenCisBox)
    .forMrGreenCip(GameSearchMrGreenCisBox)
    .apply();